<template>
  <b-modal
    content-class="mymodalContent"
    modal-class="mymodal"
    id="error"
    size="lg"
    centered
    hide-header
    hide-footer
  >
    <close-icon :title="$t('global.closePopinTitle')" @click="$bvModal.hide('error')" />
    <div class="modal-div">
      <h2 v-html="title"></h2>
      <p v-html="error"></p>
    </div>
  </b-modal>
</template>

<script>
import CloseIcon from "vue-material-design-icons/Close.vue";

export default {
  name: "PopinError",
  components: {
    CloseIcon
  },
  computed: {
    error: function() {
      return this.$store.state.appState.error.text;
    },
    title: function() {
      return this.$store.state.appState.error.title;
    }
  }
};
</script>